
import { Component, Inject } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Benefit } from '../../../models/benefit.model';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { ActivatedRoute } from '@angular/router';
import { ProductBenefit } from '../../../models/product-benefit.model';
import * as _ from 'lodash';
import { Product } from '../../../models/product.model';
import { GroupProduct } from '../../../models/group-product.model';
import { Observable } from 'rxjs/Observable';
import { Vendor } from '../../../models/vendor.model';
import { Group } from '../../../models/group.model';


@Component({
    selector: 'group-product-modal',
    template: require('./group-product-modal.component.html'),
    styles: [require('./group-product-modal.component.css')]
})
export class GroupProductModalComponent {
    group: Group;
    candidateGroupProducts: GroupProduct[];
    existedGroupProducts: GroupProduct[];

    constructor(private route: ActivatedRoute, private alertService: AlertService, private apiService: ApiService, public dialogRef: MatDialogRef<GroupProductModalComponent>,@Inject(MAT_DIALOG_DATA) public data: any) {
        this.group = data.group;
        this.init();
    }

    init() {
        this.candidateGroupProducts = [];
        this.existedGroupProducts = [];
        Observable.forkJoin([
            this.getAvailableProductsForGroup(),
            this.getExistedGroupProducts()
        ]).subscribe(results => {
            var availableProducts = results[0];
            this.existedGroupProducts = results[1];
            console.log(this.existedGroupProducts);
            _.each(availableProducts, ap => {

                this.candidateGroupProducts.push(new GroupProduct({ product: ap, productId: ap.productId, groupId: this.group.groupId }));
                
            });
        });


    }

    getAvailableProductsForGroup() {
        return this.apiService.getAvailableProductsForGroup(this.group.groupId);
    }

    getExistedGroupProducts() {
        return this.apiService.getExistedGroupProducts(this.group.groupId);
    }

    removeGroupProduct(groupProduct: GroupProduct) {
        this.apiService.removeGroupProduct(groupProduct).subscribe(r => {
            this.init();
        })
    }

    addGroupProduct(gp: GroupProduct) {
        var existing = _.some(this.existedGroupProducts, egp => {
            return egp.groupProductId == gp.groupProductId && egp.productId == gp.productId;
        })
        if (existing) {
            this.alertService.showMessage("Group ProductID " + gp.groupProductId + " already exists for LIFE Product " + gp.productId, "", MessageSeverity.error);
            return;
        }
        this.apiService.addGroupProduct(gp).subscribe(r => {
            this.alertService.showMessage("Added GroupProduct successfully!");
            this.init();
        })
    }

    ok() {
        //var selectedBenefits = _.filter(this.benefits, { 'isSelected': true });

        //var productBenefits = _.map(selectedBenefits, i => {
        //    return new ProductBenefit({ benefitId: i.benefitId, productId: this.productId });
        //})
        //this.apiService.createProductBenefitsBulk(productBenefits).subscribe(r => {
        //    if (r) {
        //        this.dialogRef.close(r);
        //    }
        //});
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/groups/group-product-modal/group-product-modal.component.ts